import * as React from "react";
import { Row, Col, Button, Icon, DatePicker } from "antd";
import styled, { ThemedStyledProps } from "styled-components";
import moment from "moment";
import { DatePickerProps } from "antd/lib/date-picker/interface";

const StyledDatePicker = styled(DatePicker)`
  input {
    height: 40px !important;
    background-color: #f2f2f2 !important;
    border: ${(
      props: ThemedStyledProps<
        DatePickerProps &
          React.RefAttributes<React.Component<DatePickerProps, any, any>>,
        any
      > & { hasError: boolean }
    ) => (props.hasError ? "1px solid #eb0333 !important" : "none !important")}
    font-size: 14px !important;
    line-height: 32px !important;
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
`;

const isDateSelectable = (date: moment.Moment): boolean => {
  const now = moment().add(1, "hours");
  // after 18 today is not selectable anymore
  if (now.hour() > 18) {
    return date < moment().endOf("day");
  } else {
    return (
      date <
      moment()
        .subtract(1, "days")
        .endOf("day")
    );
  }
};

type Props = {
  value?: moment.Moment;
  onChange: (newValue?: moment.Moment) => void;
};

type State = {};

class DayInput extends React.Component<Props, State> {
  render() {
    const { value } = this.props;
    return (
      <Row type="flex" gutter={18} align="middle">
        <Col span={4}>
          <Button
            size="small"
            type="primary"
            shape="circle"
            icon="left"
            onClick={() => this.props.onChange(value!.subtract(1, "days"))}
            disabled={
              !value || isDateSelectable(moment(value).subtract(1, "days"))
            }
          />
        </Col>
        <Col span={16}>
          <StyledDatePicker
            value={value}
            onChange={newValue => this.props.onChange(newValue || undefined)}
            format="dd., DD.MM.YYYY"
            allowClear={false}
            suffixIcon={<Icon type="calendar" style={{ color: "#386ee8" }} />}
            disabledDate={current =>
              current !== undefined && isDateSelectable(current)
            }
            hasError={!value}
            placeholder={undefined}
          />
        </Col>
        <Col span={4}>
          <Button
            size="small"
            type="primary"
            shape="circle"
            icon="right"
            onClick={() => this.props.onChange(value!.add(1, "days"))}
            disabled={!value}
          />
        </Col>
      </Row>
    );
  }
}

export default DayInput;
